import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import CardNumberInfo from '../../CardNumberInfo'
import paymentMethodTypes, { paymentMethodPropType } from '../../paymentMethodTypes'

import './PaymentMethodSummary.scss'

class PaymentMethodSummary extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    i18n: func.isRequired,
  }

  render() {
    const { paymentMethod, i18n } = this.props
    const info = paymentMethodTypes.convert(paymentMethod)

    return (
      <div className="checkout-payments checkout__payment-summary">
        <div className="checkout__payment-summary--info">
          <CardNumberInfo paymentMethod={paymentMethod} forceShowIcon />
        </div>

        <span className="checkout__payment-summary--data">{info.getSummaryData(i18n)}</span>
      </div>
    )
  }
}

export default withI18n(PaymentMethodSummary)
